import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import useDecode from "hooks/useDecode";
import useGetEconomicSheets from "services/recordSheets/useGetEconomicSheets";
import EntornoLaboral from "../Comun/EntornoLaboral";
import LoaderMin from "components/blocks/Loader/LoaderMin";
import Icon from "components/blocks/Icon/Icon";
import { SheetPage, SheetHero, SheetSection, SheetGrid, SheetField, formatText, buildEntornoLaboralProps } from "../SheetLayout";
import { moneyFormatter } from "@/services/utils/useUtils";

const BaseReguladora: React.FC = () => {
  const params = useParams<{ detailId: string; id: string }>();
  const baseReguladoraId = params.detailId?.split("__")[1];
  const prestacionId = params.id.split("_")[1];
  const { getRegulatoryBase, dataEconomicSheet: d, loadingEconomicSheet, errorEconomicSheet } = useGetEconomicSheets();
  const userId = useDecode("token")?.extension_id;

  useEffect(() => { getRegulatoryBase(userId, prestacionId, baseReguladoraId); }, []);

  if (loadingEconomicSheet) return <section className="container"><LoaderMin /></section>;
  if (errorEconomicSheet) return <section className="container"><p className="loader-text">Lo sentimos, se ha producido un error.</p></section>;
  if (!d) return <section className="container"><p className="loader-text">No hay datos para mostrar.</p></section>;

  const inactiveAlert = d.esAceptada === false
    ? <><Icon name="alert-triangle" size={16} /><span>Base Reguladora Inactiva</span></>
    : undefined;

  return (
    <SheetPage>
      <SheetHero title="Base Reguladora" icon="euro" />

      <SheetSection title="Datos Base Reguladora" icon="euro" alert={inactiveAlert}>
        <SheetGrid cols={3}>
          <SheetField label="Base Reguladora Diaria"          value={d.baseReguladoraDiaria !== undefined ? `${moneyFormatter.format(d.baseReguladoraDiaria)}` : "—"} />
          <SheetField label="Coeficiente Parcialidad Calculado" value={formatText(d.coeficienteParcialidadCalculado)} />
          <SheetField label="Descripción Cálculo"             value={formatText(d.descripcionCalculo)} wide />
        </SheetGrid>
      </SheetSection>

      {d.entornoLaboral && <EntornoLaboral {...buildEntornoLaboralProps(d)} />}
    </SheetPage>
  );
};

export default BaseReguladora;
